export default __webpack_public_path__ + "2017 Absorption and photoluminescence in organic cavity QED.pdf";